import styled from '@emotion/styled';
import { useNavigate } from 'react-router';
import { useAppSelector } from '../../../redux/store';
import useGetBillingHistory from '../../../hooks/dashboard/subscription/useGetBillingHistory';
import BillingHistoryTable from '../../../components/Subscription/BillingHistoryTable';
import LeftTriangleIcon from '../../../components/Icons/LeftTriangleIcon';

const BillingHistoryPage = () => {
  const navigate = useNavigate();
  const { loading, error } = useGetBillingHistory();
  const { billingHistory } = useAppSelector((state) => state.subscription);

  return (
    <PageContainer>
      <BackButton type="button" onClick={() => navigate(-1)} aria-label="Go back">
        <LeftTriangleIcon />
        Back
      </BackButton>

      <PageHeader>
        <Title>Billing History</Title>
        <Subtitle>View your past payments and invoices</Subtitle>
      </PageHeader>

      <Card>
        {loading ? (
          <Loading>Loading billing history...</Loading>
        ) : error ? (
          <Loading role="alert">{error}</Loading>
        ) : (
          <BillingHistoryTable history={billingHistory} />
        )}
      </Card>
    </PageContainer>
  );
};

export default BillingHistoryPage;

const PageContainer = styled.div`
  padding: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin: 0 0 1.5rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.palette.mainBlue};
  font: inherit;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;

  & > svg {
    transition: transform 0.2s ease-in-out;
  }

  &:hover > svg,
  &:focus-visible > svg {
    transform: translateX(-4px);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.mainBlue};
    outline-offset: 4px;
    border-radius: 2px;
  }
`;

const Title = styled.h1`
  margin: 0 0 0.5rem;
  font-size: 2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.greyGrey1};
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.greyGrey3};
`;

const Card = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.greyGrey5};
  border-radius: 12px;
  padding: 1.5rem;
  background: ${({ theme }) => theme.palette.white};
`;

const Loading = styled.div`
  text-align: center;
  padding: 3rem;
  color: ${({ theme }) => theme.palette.greyGrey3};
`;
